import { useTranslations } from "next-intl";

import { Badge } from "@shared/elements";

import { MESSAGE_PREFIX } from "src/constants";

/**
 * "Last used", pinned to the top-right edge of the login method the browser
 * last signed in with. The parent is positioned (`relative`); this sits on
 * its border the way the references in the task do.
 */
export default function LastUsedBadge() {
  const t = useTranslations(`${MESSAGE_PREFIX}components.LastUsedBadge`);

  return (
    <Badge
      color="primary"
      className="absolute -top-2.5 right-3 shadow-sm pointer-events-none"
    >
      {t("label")}
    </Badge>
  );
}

LastUsedBadge.messages = [`${MESSAGE_PREFIX}components.LastUsedBadge`];
